import script from "./KibotZoneListView.vue?vue&type=script&setup=true&lang=js"
export * from "./KibotZoneListView.vue?vue&type=script&setup=true&lang=js"

import "./KibotZoneListView.vue?vue&type=style&index=0&id=38162160&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38162160"]])

export default __exports__